import React from 'react';
import { APP_STORES } from 'app/javascript/constants/appStores';

interface StoreBadgesProps {
  size?: 'sm' | 'md';
  className?: string;
}

// Official "Baixar na App Store" / "Disponível no Google Play" badges linking
// to the published listings. Both assets are pre-normalized (no built-in
// padding) so a single height keeps them visually aligned.
const SIZE_CLASS: Record<NonNullable<StoreBadgesProps['size']>, string> = {
  sm: 'h-10',
  md: 'h-[52px]',
};

const StoreBadges: React.FC<StoreBadgesProps> = ({ size = 'md', className = '' }) => {
  const heightClass = SIZE_CLASS[size];

  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`}>
      <a
        href={APP_STORES.APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Baixar o BlackBelts na App Store"
        className="rounded-lg transition-opacity hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-yellow-400/60"
      >
        <img
          src="/badges/app-store-badge-pt-br.svg"
          alt="Baixar na App Store"
          className={`${heightClass} w-auto`}
          loading="lazy"
        />
      </a>
      <a
        href={APP_STORES.PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Baixar o BlackBelts no Google Play"
        className="rounded-lg transition-opacity hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-yellow-400/60"
      >
        <img
          src="/badges/google-play-badge-pt-br.png"
          alt="Disponível no Google Play"
          className={`${heightClass} w-auto`}
          loading="lazy"
        />
      </a>
    </div>
  );
};

export default StoreBadges;
